import React, { memo } from "react";
import useDuration from "../../hooks/useDuration/useDuration";

const DurationTimer = ({ startTime }) => {
  const duration = useDuration(startTime);
  return <span>{duration}</span>;
};

export default memo(DurationTimer);
